var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyRecive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8125 6.25047H20.1725C19.9825 5.98047 19.7825 5.73047 19.5725 5.48047L18.8125 6.25047Z",
    fill: "#31B7A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.52 4.42031C18.27 4.21031 18.02 4.01031 17.75 3.82031V5.18031L18.52 4.42031Z",
    fill: "#31B7A9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5834 5.48043L22.5334 2.53043C22.8234 2.24043 22.8234 1.76043 22.5334 1.47043C22.2434 1.18043 21.7634 1.18043 21.4734 1.47043L18.5234 4.42043C18.9034 4.75043 19.2534 5.11043 19.5834 5.48043Z",
    fill: "#31B7A9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7478 3C17.7478 2.59 17.4078 2.25 16.9978 2.25C16.5978 2.25 16.2778 2.57 16.2578 2.96C16.7778 3.21 17.2778 3.49 17.7478 3.82V3Z",
    fill: "#31B7A9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7519 7C21.7519 6.59 21.4119 6.25 21.0019 6.25H20.1719C20.5019 6.72 20.7919 7.22 21.0319 7.74C21.4319 7.72 21.7519 7.4 21.7519 7Z",
    fill: "#31B7A9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 14.7498H13.05C13.44 14.7498 13.75 14.3998 13.75 13.9698C13.75 13.4298 13.6 13.3498 13.26 13.2298L12.75 13.0498V14.7498Z",
    fill: "#31B7A9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.04 7.74C21.03 7.74 21.02 7.75 21 7.75H17C16.9 7.75 16.81 7.73 16.71 7.69C16.53 7.61 16.38 7.47 16.3 7.28C16.27 7.19 16.25 7.1 16.25 7V3C16.25 2.99 16.26 2.98 16.26 2.96C14.96 2.35 13.52 2 12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 10.48 21.65 9.04 21.04 7.74ZM13.75 11.82C14.39 12.04 15.25 12.51 15.25 13.98C15.25 15.23 14.26 16.26 13.05 16.26H12.75V16.51C12.75 16.92 12.41 17.26 12 17.26C11.59 17.26 11.25 16.92 11.25 16.51V16.26H11.17C9.84 16.26 8.75 15.14 8.75 13.76C8.75 13.34 9.09 13 9.5 13C9.91 13 10.25 13.34 10.25 13.75C10.25 14.3 10.66 14.75 11.17 14.75H11.25V12.53L10.25 12.18C9.61 11.96 8.75 11.49 8.75 10.02C8.75 8.77 9.74 7.74 10.95 7.74H11.25V7.5C11.25 7.09 11.59 6.75 12 6.75C12.41 6.75 12.75 7.09 12.75 7.5V7.75H12.83C14.16 7.75 15.25 8.87 15.25 10.25C15.25 10.66 14.91 11 14.5 11C14.09 11 13.75 10.66 13.75 10.25C13.75 9.7 13.34 9.25 12.83 9.25H12.75V11.47L13.75 11.82Z",
    fill: "#31B7A9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 10.03C10.25 10.57 10.4 10.65 10.74 10.77L11.25 10.95V9.25H10.95C10.57 9.25 10.25 9.6 10.25 10.03Z",
    fill: "#31B7A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyRecive);
export default __webpack_public_path__ + "static/media/money-recive.571fee67ad6ff9a21658e768ff8fe82b.svg";
export { ForwardRef as ReactComponent };